module.exports = __webpack_public_path__ + "media/entities/1605-933ac6b1.png";